import { connect } from 'react-redux';
import React, { useRef, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import {
  Button,
  Container,
  InnerContain,
  MarginBottom,
  OrderContain,
  UploadContain,
  InnerContainer
} from './Styled';

import Order from './Order';
import OrderNotFound from './OrderNotFound';

import useUploadDialog from './useUploadDialog';

import { updateOrder, fetchOrder, setActive, uploadDocument, updateActiveOrder, requestUpdatedCertificate } from 'actions/orders';
import { errorInputClear, errorClear } from 'actions/error';

import {
  titleSelector,
  orderIdSelector,
  activeOrderSelector
} from 'selectors/order';

import { getOrderIdFromParams, canUpload } from 'utils';

const OrderContainer = ({
  order,
  inputErrors,
  errorMessage,
  loadingOrder,
  orderUpdated,
  activeOrderId,
  loadingUpload,
  dispatchSetActive,
  loadingOrderUpdate,
  dispatchFetchOrder,
  dispatchErrorClear,
  dispatchUpdateOrder,
  dispatchRequestUpdate,
  dispatchUploadDocument,
  dispatchUpdateNewOrder, 
  dispatchErrorInputClear,
  ...props
}) => {
  const documents = (order && order.documents) ? order.documents : [];
  const orderId = getOrderIdFromParams(props) || activeOrderId;
  const documentCount = useRef(documents.length);

  useEffect(() => {
    if (orderId !== activeOrderId) {
      dispatchSetActive(orderId);
    }

    dispatchFetchOrder(orderId);
  }, [dispatchFetchOrder, dispatchSetActive, orderId, activeOrderId]);

  const handleUpdateOrder = (values) => {
    dispatchUpdateOrder(values);
  };

  const handleUpdateNewOrder = (values) => {
    dispatchUpdateNewOrder(values);
  }

  const handleUpload = (file, description) => {
    dispatchUploadDocument(file, description);
  };

  const handleRequestUpdate = ( orderId, itemId ) => {
    dispatchRequestUpdate(orderId, itemId);
  };

  const handleErrorClear = () => {
    dispatchErrorClear();
    dispatchErrorInputClear();
  }

  const [renderUploadDialog, openUpload, closeUpload] = useUploadDialog(
    handleUpload,
    handleErrorClear
  );

  useEffect(() => {
    if (documentCount.current !== documents.length) {
      documentCount.current = documents.length;
      closeUpload();
    }
  }, [closeUpload, documents]);

  const renderUpload = () => canUpload(order) && (
    <UploadContain>
      <Button fullWidth secondary onClick={openUpload}>
        Upload Document
      </Button>
    </UploadContain>
  );

  return (
    <Container>
      <InnerContainer>
        <OrderContain>
          <InnerContain>
            <MarginBottom />

            {!order && !loadingOrder ? (
              <OrderNotFound />
            ) : (
              <Order
                order={order}
                loading={loadingOrder}
                inputErrors={inputErrors}
                orderUpdated={orderUpdated}
                is_postpaid={props.is_postpaid}
                updateOrder={handleUpdateOrder}
                updateNewOrder={handleUpdateNewOrder}
                loadingOrderUpdate={loadingOrderUpdate}
                renderUpload={renderUpload}
                errorMessage={errorMessage}
                requestUpdate={handleRequestUpdate}
              />
            )}
          </InnerContain>
        </OrderContain>
      </InnerContainer>
      {renderUploadDialog({ loading: loadingUpload, errorMessage })}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  title: titleSelector(state),
  is_postpaid: state.session.account.is_postpaid,
  activeOrderId: orderIdSelector(state),
  order: activeOrderSelector(state),
  errorMessage: state.error.message,
  inputErrors: state.error.inputErrors,
  orderUpdated: state.orders.orderUpdated,
  loadingOrder: state.loading.loadingOrder,
  loadingUpload: state.loading.loadingUpload,
  loadingOrderUpdate: state.loading.loadingOrderUpdate
});

const mapDispatchToProps = {
  dispatchSetActive: setActive,
  dispatchFetchOrder: fetchOrder,
  dispatchErrorClear: errorClear,
  dispatchUploadDocument: uploadDocument,
  dispatchErrorInputClear: errorInputClear,
  dispatchUpdateOrder: updateActiveOrder,
  dispatchRequestUpdate: requestUpdatedCertificate,
  dispatchUpdateNewOrder: updateOrder
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrderContainer)
);
